/** Labels the backend could not print, from a kitting print response. */
export function kittingWarnings(result: unknown): string[] {
	if (!result || typeof result !== 'object' || !('warnings' in result)) {
		return [];
	}
	const warnings = (result as { warnings?: unknown }).warnings;
	if (!Array.isArray(warnings)) {
		return [];
	}
	return warnings.filter((warning): warning is string => typeof warning === 'string');
}
